import { render } from "./ViewHousePage.vue?vue&type=template&id=7378d799&ts=true"
import script from "./ViewHousePage.vue?vue&type=script&lang=ts"
export * from "./ViewHousePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__